import { observer } from 'mobx-react-lite';
import React from 'react';
import { useStores } from '../../common/hooks';
import NominationDashboardPage from '../page-nomination-dashboard/NominationDashboardPage';
import NoAccess from '../shared-components/NoAccess';
import { Navigate } from 'react-router';
import { RoutePaths } from '../../route-paths';

interface HomePageProps {
  programId: number;
  isShowSubmitNominationSuccessToast: boolean;
}

const HomePage: React.FC<HomePageProps> = (props) => {
  const {
    programId,
    isShowSubmitNominationSuccessToast
  } = props;

  const { userStore } = useStores();

  const getRedirectPath = (): string | undefined => {
    if ((userStore.isAdmin || userStore.isLead || userStore.isReviewer) && !userStore.isShowPartnerPage) {
      return RoutePaths.ProgramDashboard;
    }
    if ((userStore.isJudge || userStore.isNominationJudge) && !userStore.isShowPartnerPage) {
      return RoutePaths.JudgingDashboard;
    }
    return undefined;
  };

  const redirectPath = getRedirectPath();
  if (redirectPath) {
    return <Navigate to={redirectPath} replace />;
  }

  return (userStore.isPartner && userStore.isShowPartnerPage && userStore.accountHasAccess) ? (
    <NominationDashboardPage
      programId={programId}
      isShowSubmitNominationSuccessToast={isShowSubmitNominationSuccessToast}
    />
  ) : <NoAccess />;

};

export default observer(HomePage);